export default __webpack_public_path__ + "static/Tek_Catwalk-e99adeb14f6ab18ebee684d2ece2c165.png";